import { createFileRoute } from "@tanstack/react-router";
import { IntroScreen } from "@ui/screens/IntroScreen";

export const Route = createFileRoute("/intro")({
  component: IntroScreen,
});
